import { Member, Role, User, Workspace } from '@prisma/client';

export interface AddMemberBodyParams {
  emails: NonNullable<Member['email']>[];
  role: NonNullable<Role>;
  permissions: MemberPermissions;
}

export type MemberWithWorkspace = Member & {
  workspace: Workspace;
};
export type MemberUser = Pick<
  User,
  'displayname' | 'email' | 'avatar' | 'avatarBackground' | 'avatarEmoji' | 'timezone'
> | null;

// TODO: Add additional permissions
export enum MemberPermission {
  TODO,
}

export enum MemberPermissionType {
  Simple = 'simple',
}

export type MemberPermissionValue = {
  type: MemberPermissionType.Simple;
  available: boolean;
};

export type MemberPermissions = Record<MemberPermission, MemberPermissionValue>;
export type MemberWithPermissions = Omit<Member, 'permissions'> & { permissions?: MemberPermissions };
export type MemberWithUser = MemberWithPermissions & { user?: MemberUser };
export type ListMembersResponse = Array<MemberWithUser>;

export interface UpdateMemberParams {
  role: NonNullable<Role>;
  permissions: MemberPermissions;
}
